import { Component, Input, OnInit, AfterViewInit, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { BindComponentService } from '../../../../../../app/utils/bind.component.service';
import { DataPackService } from '../../../../../models/DataPackService.model';
import { BlockGroupService } from '../../../../../../app/services/block.group.service';
import { AlertService } from '../../../../../../app/utils/alert.service';
import { DataPackLineAcount } from '../../../../../models/dataPackLineAcount.model';
import { DataBlockComponent } from '../../data/content.component';
import { LoadingComponent } from '../../../modalLoading/content.component';
import { ModalBloqueioVozComponent } from '../blockModal/content.component';
import { DataPackLine } from '../../../../../../app/models/dataPackLine.model';
import { DataPackSelectItem } from '../../../../../models/DataPackSelectItem.model';
import { ConfirmMassiveBlockConfigurationComponent } from '../../../../../../app/home/paraEmpresas/block/voice/config/confirm/content.component';

  import * as _ from "lodash";
import { removeDebugNodeFromIndex } from '@angular/core/src/debug/debug_node';
import { forEach } from '@angular/router/src/utils/collection';
import { DataPackGroup } from 'app/models/dataPackGroup.model';


/**
 * @version $Id: content.component.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
 */
@Component({
  selector: 'configBlockVoiceComponent',
  templateUrl: './content.template.html'
})
@Injectable()
export class ConfigBlockVoiceComponent implements OnInit, AfterViewInit {

  @Input() private isAccess:boolean;
  @Input() private lineAcountList: any[];
  @Input() private lineNew: DataPackLine = new DataPackLine();
  @Input() private listOpcoesBlockLines: Map<string, DataPackService> = new Map<string, DataPackService>();
  @Input() private groupNew: DataPackGroup = new DataPackGroup();

  static BLK_OPER = 'BLK_OPER';
  static BLK_WLIST = 'BLK_WLIST';
  static BLK_PREFIX = 'BLK_PREFIX';
  static BLK_TARIF = 'BLK_TARIF';
  static RAM_EXT = 'RAM_EXT';
  static BLK_GRP = 'BLK_GRP';
  static MOVEL_LISTA = 'MOVEL_LISTA';
  private opAuthCount:number = 0;
  private opNotAuthCount:number = 0;
  private initialCarriersList: any[];
  private tmpRemovedCarriersList: any[];
  private selectItemList: any[];
  private tmpAddedCarriersList: any[];
  private initialBlockedNumber: any[];
  private tmpAddedBlockedNumber: any[];
  private tmpRemovedBlockedNumber: any[];

  private val: any[];
  private dataLineAcount: DataPackLineAcount = new DataPackLineAcount();
  private menuSelecionado: DataPackService;
  private selectedActiveBlocked: Map<string, DataPackService> = new Map<string, DataPackService>();
  private selectedDesativeBlocked: Map<string, DataPackService> = new Map<string, DataPackService>();
  private selectedInheritorBlocked: Map<string, DataPackService> = new Map<string, DataPackService>();
  private listSelectedService: Array<DataPackService> = new Array<DataPackService>();
  private listBlocked: Map<string, DataPackService> = new Map<string, DataPackService>();
  
  private selectItem: DataPackSelectItem = new DataPackSelectItem();
  private numeroAutorizado: string;
  private numeroNaoAutorizado: string;
  private numeroExecoes: string;
  private numeroMovel: string;
  private form: FormGroup;
  private isSelecaoMultipla: boolean;
  private patternNumber:String = '^0[0-9^%]{2,}$';
  private pattern: string = '^0\\d{11}|\\d{3}|^[%]$';
  private patternMovel: string = '(^0[0-9]{2})9?[0-9]{8}$';
  private patternDefault: string = '(^0[0-9]{2})9?%?[0-9^%]{0,8}$';
  private patternEmpty: string = '^\\d+$'; //^\\d+$|^0\\d{11}|^[%]
  private maxLimit:number;
  private oldCarriersListLength:number;
  private oldBlockedNumberLength:number;
  private addFlagCarriersListLength :boolean = false;
  private addFlagBlockedNumberLength :boolean = false;
  private delFlagCarriersListLength :boolean = false;
  private delFlagBlockedNumberLength :boolean = false;

  constructor(private bindComponent: BindComponentService, private formBuilder: FormBuilder, private blockGroupService: BlockGroupService, private alertService: AlertService, private modalService: NgbModal) {

  }

  public ngOnInit() {
    this.loadView();
    this.form = this.formBuilder.group({
      numeroAutorizado: [this.numeroAutorizado, Validators.compose([Validators.required, Validators.pattern(this.patternDefault)])],
      numeroNaoAutorizado: [this.numeroNaoAutorizado, Validators.compose([Validators.required, Validators.pattern(this.patternDefault)])],
      numeroExecoes: [this.numeroExecoes, Validators.compose([Validators.required, Validators.pattern(this.patternDefault)])],
      numeroMovel: [this.numeroMovel, Validators.compose([Validators.required, Validators.pattern(this.patternMovel)])]
    });
    if(this.isAccess){
      this.maxLimit =50;
    }
    this.lineNew.facilityDataPackServices.forEach(facility => {
      if (facility.serviceCode =='BLK_PREFIX') {
        this.oldBlockedNumberLength = facility.blockedNumber.length;
      }
      if (facility.serviceCode =='BLK_WLIST') {
        this.oldCarriersListLength = facility.carriersList.length;
      }
    });    
  }

  private loadView() {
    if (this.lineAcountList != null && this.lineAcountList.length > 1) {
      this.isSelecaoMultipla = true;
    } else {
      this.isSelecaoMultipla = false;
    }
  }

  ngAfterViewInit() {
    if (this.isSelecaoMultipla) {
      this.destativarBLK();
    }
    this.lineNew.facilityDataPackServices.forEach(facility => {
      if (facility.serviceCode =='BLK_PREFIX') {
        this.initialBlockedNumber = [];
        this.tmpAddedBlockedNumber = [];
        this.tmpRemovedBlockedNumber = [];
        facility.blockedNumber.forEach(item=>{
          this.initialBlockedNumber.push(item);
       })
      }
      if (facility.serviceCode =='BLK_WLIST') {
        this.initialCarriersList = [];
        this.tmpAddedCarriersList = [];
        this.tmpRemovedCarriersList = [];
        facility.carriersList.forEach(item=>{
          this.initialCarriersList.push(item);
       });
      }
    }); 
  }

  private loadAfterView() {
    this.blockGroupService.getLineData(this.lineAcountList).subscribe(
      data => {
        let value:any = data;
        this.lineNew = value;
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  public selectOPER($event: any) {
    this.selectItem = new DataPackSelectItem();
    var isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);
    var isIE10 = /Trident.*rv[ :]*10\./.test(navigator.userAgent);
    var isIE9 = /Trident.*rv[ :]*9\./.test(navigator.userAgent);
  
    let obj = $event.target;
    var list = [];
    this.selectItemList = [];
    if(obj.selectedOptions != undefined){
      list = obj.selectedOptions;
      var index; 
      for (index = 0; index < list.length; index++) {       
        let oper = new DataPackSelectItem();          
            oper.id = list[index].id;
            oper.description = list[index].text;
            this.selectItemList.push(oper);
      }
    }
    else{
      let oper = new DataPackSelectItem();         
      oper.id = obj.id;
      oper.description = obj.text;
      this.selectItemList.push(oper);
    }
  
    if(isIE11 || isIE10 || isIE9){
      if(obj.options[obj.selectedIndex]!=undefined){
        let oper = new DataPackSelectItem();

         oper.id = obj.options[obj.selectedIndex].id;
        oper.description = obj.options[obj.selectedIndex].text;
        this.selectItem = oper;
      }  
    }else{
      let oper = new DataPackSelectItem();
      oper.id = obj.id;
      oper.description = obj.label;
      this.selectItem = oper;
    }    

  }

  private verificarBloqueio(nome: any) {
    if (ConfigBlockVoiceComponent.BLK_OPER === nome) {
      return ConfigBlockVoiceComponent.BLK_OPER;
    } else if (ConfigBlockVoiceComponent.BLK_WLIST === nome) {
      return ConfigBlockVoiceComponent.BLK_WLIST;
    } else if (ConfigBlockVoiceComponent.BLK_PREFIX === nome) {
      return ConfigBlockVoiceComponent.BLK_PREFIX;
    } else if (ConfigBlockVoiceComponent.BLK_TARIF === nome) {
      return ConfigBlockVoiceComponent.BLK_TARIF;
    } else if (ConfigBlockVoiceComponent.RAM_EXT === nome) {
      return ConfigBlockVoiceComponent.RAM_EXT;
    } else if (ConfigBlockVoiceComponent.BLK_GRP === nome) {
      return ConfigBlockVoiceComponent.BLK_GRP;
    } else if (ConfigBlockVoiceComponent.MOVEL_LISTA === nome) {
      return ConfigBlockVoiceComponent.MOVEL_LISTA;
    }

  }

  public addNotAuthorizedList(opcao: DataPackService) {
    this.selectItem = new DataPackSelectItem();
    this.numeroNaoAutorizado = this.form.controls['numeroNaoAutorizado'].value;
    if (this.numeroNaoAutorizado != undefined && this.numeroNaoAutorizado != '') {
      if(this.existsNumber(opcao.blockedNumber, this.numeroNaoAutorizado)){
      	this.alertService.warn("Lista não pode ter elementos repetidos.");
      }else{
        if (this.existsNumber(this.initialBlockedNumber, this.numeroNaoAutorizado)){
          if (this.removeItemFromList(this.tmpRemovedBlockedNumber, this.numeroNaoAutorizado)){
            this.opNotAuthCount--;
          }    
        }else{
          this.opNotAuthCount++;
        }
      this.listBlocked.delete(opcao.serviceCode);
      this.selectItem.id = this.numeroNaoAutorizado.toString();
      this.selectItem.memberInfo = 'B';
      opcao.blockedNumber.push(this.selectItem);
      this.listBlocked.set(opcao.serviceCode,opcao);
      this.clearSelectionList();
    }
  }
}

  private removeNotAuthorizedList(opcao: DataPackService) {
    this.selectItemList.forEach(element => {
      if (element != undefined) {
        if(this.existsNumber(this.initialBlockedNumber, element.id)){
          this.opNotAuthCount++;
          this.tmpRemovedBlockedNumber.push(element.id);
        }else{
          this.opNotAuthCount--;
        }
        this.listBlocked.delete(opcao.serviceCode);
        this.removeItemFromList(opcao.blockedNumber,element.id);
        this.clearSelectionList();
        this.listBlocked.set(opcao.serviceCode,opcao);
      }
    });
  }

  public removeItemCarrierList(opcao: DataPackService){
    let index:number;
    opcao.carriersList.forEach(option => {
      if (option.id === this.selectItem.id) {
        index = opcao.carriersList.indexOf(option);
      }
    });
    opcao.carriersList.splice(index, 1);
  }

  public removeItemBlockedNumber(opcao: DataPackService){
    let index:number;
    opcao.blockedNumber.forEach(option => {
      if (option.id === this.selectItem.id) {
        index = opcao.blockedNumber.indexOf(option);
      }
    });
    opcao.blockedNumber.splice(index, 1);
  }



  public addExceptionsList(opcao: DataPackService) {
    this.selectItem = new DataPackSelectItem();
    this.numeroExecoes = this.form.controls['numeroExecoes'].value;
    if (this.numeroExecoes != undefined && this.numeroExecoes != '') {
      this.listBlocked.delete(opcao.serviceCode);
      this.selectItem.id = this.numeroExecoes.toString();
      this.selectItem.memberInfo = 'E';
      opcao.allowedNumber.push(this.selectItem);
      this.listBlocked.set(opcao.serviceCode,opcao);
      this.clearSelectionList();
    }
  }


  private removeExceptionsList(opcao: DataPackService) {
    if (this.selectItem != undefined) {
      this.listBlocked.delete(opcao.serviceCode);
      this.removeItemAllowedNumberList(opcao);
      this.clearSelectionList();
      this.listBlocked.set(opcao.serviceCode,opcao);
    }
  }

  public removeItemAllowedNumberList(opcao: DataPackService){
    let index:number;
    opcao.allowedNumber.forEach(option => {
      if (option.id === this.selectItem.id) {
        index = opcao.allowedNumber.indexOf(option);
      }
    });
    opcao.allowedNumber.splice(index, 1);
  }


  public addAuthorizedList(opcao: DataPackService) {
    this.selectItem = new DataPackSelectItem();
    this.numeroAutorizado = this.form.controls['numeroAutorizado'].value;
    if (this.numeroAutorizado != undefined && this.numeroAutorizado != '') {
      if(this.existsMsisdn(opcao)){
      	this.alertService.warn("Lista não pode ter elementos repetidos.");
      }else{
        if(this.existsNumber(this.initialCarriersList, this.numeroAutorizado)){
          if(this.removeItemFromList(this.tmpRemovedCarriersList, this.numeroAutorizado)){
            this.opAuthCount--;
          }    
        }else{
          this.opAuthCount++;
        }
	      this.listBlocked.delete(opcao.serviceCode);
	      this.selectItem.id = this.numeroAutorizado.toString();
	      opcao.carriersList.push(this.selectItem);
	      this.listBlocked.set(opcao.serviceCode,opcao);
	      this.clearSelectionList();
      }
    }
  }

  private removeAuthorizedList(opcao: DataPackService) {
    this.selectItemList.forEach(element => {
      if (element != undefined) {
        if(this.existsNumber(this.initialCarriersList, element.id)){
          this.opAuthCount++;
          this.tmpRemovedCarriersList.push(element.id);
        }else{
          this.opAuthCount--;
        }
        this.removeAuthList(opcao, element.id);
      }
    });    
  }
  
  public addMovelList(opcao: DataPackService) {
    this.selectItem = new DataPackSelectItem();
    this.numeroMovel = this.form.controls['numeroMovel'].value;
    if (this.numeroMovel != undefined && this.numeroMovel != '' && this.validateDDD(this.numeroMovel)) {
      this.listBlocked.delete(opcao.serviceCode);
      let indexCarrier =  opcao.carriersListAll.indexOf(this.selectItem);
      opcao.carriersListAll.splice(indexCarrier, 1);

      this.selectItem.id = this.numeroMovel.toString();
      opcao.carriersList.push(this.selectItem);
      this.listBlocked.set(opcao.serviceCode,opcao);
      this.clearSelectionList();
    }
  }

  private removeMovelList(opcao: DataPackService) {
    this.removeList(opcao);
  }


  public removeList(opcao: DataPackService){
    if (this.selectItem != undefined) {
      this.listBlocked.delete(opcao.serviceCode);
      this.removeItemCarrierList(opcao);
      this.clearSelectionList();
      this.listBlocked.set(opcao.serviceCode,opcao);
    }
  }

  public removeAuthList(opcao: DataPackService, choice: any){
    if (this.selectItemList.length > 0) {
      this.listBlocked.delete(opcao.serviceCode);
      this.removeItemFromList(opcao.carriersList, choice);
      this.clearSelectionList();
      this.listBlocked.set(opcao.serviceCode,opcao);
    }
  }

  public validateDDD(msisdn: String): boolean {
    var dddLinhaSelect = this.lineNew.lineNumber.substring(0, 2);
    var dddInformado = msisdn.substring(1, 3);
    if (dddLinhaSelect == dddInformado) {
      return true;
    }
    this.alertService.error( 'Número ' + msisdn + ' inválido. O número configurado deve pertencer ao mesmo DDD ('+ dddLinhaSelect + ') da linha que possui o serviço Móvel Lista.',null);
    return false;
  }


  public clearSelectionList() {
    this.form.controls['numeroAutorizado'].setValue('');
    this.form.controls['numeroAutorizado'].setErrors(null);
    this.form.controls['numeroNaoAutorizado'].setValue('');
    this.form.controls['numeroNaoAutorizado'].setErrors(null);
    this.form.controls['numeroExecoes'].setValue('');
    this.form.controls['numeroExecoes'].setErrors(null);
    this.form.controls['numeroMovel'].setValue('');
    this.form.controls['numeroMovel'].setErrors(null);
    this.numeroMovel = undefined;
    this.numeroAutorizado = undefined;
    this.selectItem = undefined;
  }

  private addOperators(facility: DataPackService, options: Array<DataPackSelectItem>) {
	  
    if(options.length===this.maxLimit || !this.isAccess){
      this.alertService.warn("Número máximo de modificações alcançado. Favor submeter lista.");
      return;
    }
    
    if(options.length > 0) {
    	
      this.listBlocked.delete(facility.serviceCode);
      
      options.forEach(option => {
        if (option != undefined) {
          let index: number;
          
          facility.carriersListAll.forEach(carrier => {
              if (carrier.id === option.id) {
                index = facility.carriersListAll.indexOf(carrier);
              }
            });
          
          if(facility.carriersList.length>=this.maxLimit && this.isAccess){
            this.maxLimit = this.maxLimit+facility.carriersList.length;
            this.isAccess =false;
          }
      
          facility.carriersListAll.splice(index, 1);
          facility.carriersList.push(option);
          this.clearSelectionList();
        }
      });
      
      this.listBlocked.set(facility.serviceCode,facility);
    }
  }

  private addAllOperators(opcao: DataPackService) {
    let isreachedLimit:boolean=false;
    this.listBlocked.delete(opcao.serviceCode);
    let cont:number = 0;
    if(opcao.carriersList.length>=this.maxLimit && this.isAccess){
      this.maxLimit = this.maxLimit+opcao.carriersList.length;
      this.isAccess =false;
    }
    opcao.carriersListAll.forEach(carrier=>{
      cont++;
      if(cont<=this.maxLimit  &&  (opcao.carriersList.length<=this.maxLimit)){
        opcao.carriersList =  opcao.carriersList.concat(carrier);
      }else{
        isreachedLimit=true;
      }

    });
    if(isreachedLimit){
      this.alertService.warn("Número máximo de modificações alcançado. Favor submeter lista.");
    }
    
    opcao.carriersList.forEach(carrier=>{
      let index = opcao.carriersListAll.indexOf(carrier);
      opcao.carriersListAll.splice(index, 1);  
    });
    
    this.listBlocked.set(opcao.serviceCode,opcao);
    this.clearSelectionList();
  }

  private removeOperators(facility: DataPackService, options: Array<DataPackSelectItem>) {
	  
	if(options.length > 0) {
	  this.listBlocked.delete(facility.serviceCode);
	  options.forEach(option => {
	    if (option != undefined) {
          let index:number;
          facility.carriersList.forEach(carrier => {
            if (carrier.id === option.id) {
              index = facility.carriersList.indexOf(carrier);
            }
          });
          facility.carriersList.splice(index, 1);
          facility.carriersListAll.push(option);
          this.clearSelectionList();
        }
	  });
	  this.listBlocked.set(facility.serviceCode,facility);
	}
  }

  private removeAllOperators(opcao: DataPackService) {
    if (opcao.carriersList.length > 0) {
        this.listBlocked.delete(opcao.serviceCode);
        opcao.carriersListAll = opcao.carriersListAll.concat(opcao.carriersList);
        opcao.carriersList = new Array<DataPackSelectItem>();
        this.listBlocked.set(opcao.serviceCode,opcao);
        this.clearSelectionList();
    }
  }

  private selectOneAtctive($event: { srcElement: { checked: any; }; }, opcao: DataPackService) {
    let check = $event.srcElement.checked;
    if (check) {
      if (this.selectedDesativeBlocked.has(opcao.serviceCode)) {
        this.selectedDesativeBlocked.delete(opcao.serviceCode);
        this.listBlocked.delete(opcao.serviceCode);
      }
      if (this.selectedInheritorBlocked.has(opcao.serviceCode)) {
        this.selectedInheritorBlocked.delete(opcao.serviceCode);
        this.listBlocked.delete(opcao.serviceCode);
      }
      this.selectedActiveBlocked.set(opcao.serviceCode, opcao);
      opcao.serviceState = 'ACT';
      this.listBlocked.set(opcao.serviceCode,opcao);
    } else {
      this.selectedActiveBlocked.delete(opcao.serviceCode);
      this.listBlocked.delete(opcao.serviceCode);
    }
  }

  private selectOneDesative($event: { srcElement: { checked: any; }; }, opcao: DataPackService) {
    let check = $event.srcElement.checked;
    if (check) {
      if (this.selectedActiveBlocked.has(opcao.serviceCode)) {
        this.selectedActiveBlocked.delete(opcao.serviceCode);
        this.listBlocked.delete(opcao.serviceCode);
      }
      if (this.selectedInheritorBlocked.has(opcao.serviceCode)) {
        this.selectedInheritorBlocked.delete(opcao.serviceCode);
        this.listBlocked.delete(opcao.serviceCode);
      }
      this.selectedDesativeBlocked.set(opcao.serviceCode, opcao);
      if(opcao.serviceCode == 'BLK_WLIST' || opcao.serviceCode == 'BLK_PREFIX') {
        opcao.serviceState = 'SUS';
      } else {
        opcao.serviceState = 'BLK';
      }
      this.listBlocked.set(opcao.serviceCode,opcao);
    } else {
      this.selectedDesativeBlocked.delete(opcao.serviceCode);
      this.listBlocked.delete(opcao.serviceCode);
    }
  }

  private selectOneInheritor($event: { srcElement: { checked: any; }; }, opcao: DataPackService, control: boolean) {
    let check = $event.srcElement.checked;
    if (check) {
      if (this.selectedActiveBlocked.has(opcao.serviceCode)) {
        this.selectedActiveBlocked.delete(opcao.serviceCode);
        this.listBlocked.delete(opcao.serviceCode);
      }
      if (this.selectedDesativeBlocked.has(opcao.serviceCode)) {
        this.selectedDesativeBlocked.delete(opcao.serviceCode);
        this.listBlocked.delete(opcao.serviceCode);
      }
      this.selectedInheritorBlocked.set(opcao.serviceCode, opcao);
      if(control){
        opcao.serviceState = 'DES'
      }else{
        opcao.serviceState = 'SUS';
      }
      this.listBlocked.set(opcao.serviceCode,opcao);
    } else {
      this.selectedInheritorBlocked.delete(opcao.serviceCode);
      this.listBlocked.delete(opcao.serviceCode);
    }
  }

  public exibirStatus(opcao: DataPackService) {
    if (this.isSelecaoMultipla) {
      return '';
    } else if (opcao.serviceState === 'DES') {
      return 'Desativado';
    } else if (opcao.serviceState === 'ACT') {
      return 'Ativado';
    } else if (opcao.serviceState === 'SUS') {
      return 'Suspenso';
    } else if (opcao.serviceState === 'BLK') {
      return 'Desativado';
    }  
  }

  public destativarBLK() {
    this.lineNew.lineControlDataPackServices.forEach(control => {
      if (!this.listOpcoesBlockLines.has(control.serviceCode)) {
        document.getElementById(control.serviceCode + '-band') && document.getElementById(control.serviceCode + '-band').classList.add('displayNone')
      }
    });
    this.lineNew.facilityDataPackServices.forEach(facility => {
      if (!this.listOpcoesBlockLines.has(facility.serviceCode)) {
        document.getElementById(facility.serviceCode + '-band') && document.getElementById(facility.serviceCode + '-band').classList.add('displayNone')
      }
    });
  }

  private toggleGroup(opcao: DataPackService, $event: { stopPropagation: { (): void; (): void; }; preventDefault: { (): void; (): void; }; }) {
    if(!opcao.editable && !this.isSelecaoMultipla){
       $event.stopPropagation();
       $event.preventDefault();
    }
    if (this.isSelecaoMultipla) {
      if (this.listOpcoesBlockLines.has(opcao.serviceCode)) {
        this.carregarArcordionMutipleLine(opcao)
      } else {
        $event.stopPropagation();
        $event.preventDefault();
      }
    } else if (!this.isSelecaoMultipla) {
      this.carregarArcordionOneLine(opcao);
    }
  }

  private carregarArcordionMutipleLine(opcoes: DataPackService) {
    if (!this.menuSelecionado || this.menuSelecionado.id !== opcoes.id) {
      this.menuSelecionado = opcoes;
    } else {
      this.menuSelecionado = null;
    }
    this.selectedActiveBlocked = new Map<string, DataPackService>();
    this.selectedDesativeBlocked = new Map<string, DataPackService>();
    this.selectedInheritorBlocked = new Map<string, DataPackService>();

  }

  private carregarArcordionOneLine(opcoes: DataPackService) {
    if (!this.menuSelecionado || this.menuSelecionado.serviceCode !== opcoes.serviceCode) {
      this.menuSelecionado = opcoes;
    } else {
      this.menuSelecionado = null;
    }
    this.selectedActiveBlocked = new Map<string, DataPackService>();
    this.selectedDesativeBlocked = new Map<string, DataPackService>();
    this.selectedInheritorBlocked = new Map<string, DataPackService>();
    if (opcoes.serviceState === 'ACT') {
      this.selectedActiveBlocked.set(opcoes.serviceCode, opcoes);
    }else if (this.isInheritor(opcoes)) {
      this.selectedInheritorBlocked.set(opcoes.serviceCode, opcoes);
    }else if (opcoes.serviceState === 'BLK') {
      this.selectedDesativeBlocked.set(opcoes.serviceCode, opcoes);
    }else if (opcoes.serviceState === 'DES') {
      this.selectedDesativeBlocked.set(opcoes.serviceCode, opcoes);
    }else if (opcoes.serviceState === 'SUS') {
      this.selectedDesativeBlocked.set(opcoes.serviceCode, opcoes);
    }
  }

  public cancelar() {
    this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, false);
    this.clear();
  }

  clear() {
    this.lineNew = new DataPackLine();
    this.dataLineAcount = new DataPackLineAcount();
    this.listOpcoesBlockLines = new Map<string, DataPackService>();
    this.menuSelecionado = new DataPackService();
    this.selectedActiveBlocked = new Map<string, DataPackService>();
    this.selectedDesativeBlocked = new Map<string, DataPackService>();
    this.selectedInheritorBlocked = new Map<string, DataPackService>();

  }

  public salvarAlteracoes() {
    this.listBlocked.forEach(service => { 
      this.listSelectedService.push(service);
    });
    this.dataLineAcount.lineAcountList = this.lineAcountList;
    this.dataLineAcount.lineServiceUpdateMultiplo = this.listSelectedService;
    if (this.isSelecaoMultipla) {
      this.openConfirmModal();
    } else {
      this.update();
    }
  }

  public update() {
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.blockGroupService.saveLockVoice(this.dataLineAcount).subscribe(data => {
    this.alertService.success('Atualizado com Sucesso!');
      this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, false);
    },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private openConfirmModal() {
    let modalRef = this.modalService.open(ConfirmMassiveBlockConfigurationComponent);
    modalRef.componentInstance.dataLineAcount = this.dataLineAcount;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private maskMsisdn(msisdn: string): string {
    if (_.isNil(msisdn)) {
      return '';
    }
    if (msisdn.length == 12) {
      return '('.concat(msisdn.substr(0, 3)).concat(') ').concat(msisdn.substring(3, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    } else if (msisdn.length == 11) {
      return '('.concat(msisdn.substr(0, 2)).concat(') ').concat(msisdn.substring(2, (msisdn.length - 4))).concat('-').concat(msisdn.substr(-4, 4));
    }
    return msisdn;
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  public isInheritor(opcao: DataPackService){
    if(opcao.allowInheritance && (opcao.serviceState === 'DES' || opcao.serviceState === 'SUS')){
      return true;
    }
    return false;
  }

  private addCarriersListValidatorLength(facilities: DataPackService){
    this.delFlagCarriersListLength = false;
    if(Math.abs(facilities.carriersList.length - this.oldCarriersListLength) >= 2 ){
      this.addFlagCarriersListLength = true;
      return true;
    }
    this.addFlagCarriersListLength = false;
    return false;
  }
  
  private addBlockedNumberValidatorLength(facilities: DataPackService){
    this.delFlagBlockedNumberLength = false;
    if(Math.abs(facilities.blockedNumber.length - this.oldBlockedNumberLength) >= 2 ){
      this.addFlagBlockedNumberLength = true;
      return true;
    }
    this.addFlagBlockedNumberLength = false;
    return false;
  }

  private delCarriersListValidatorLength(facilities: DataPackService){
    this.addFlagCarriersListLength = false;
    if(Math.abs(facilities.carriersList.length - this.oldCarriersListLength) >= 2 ){
      this.delFlagCarriersListLength = true;
      return true;
    }
    this.delFlagCarriersListLength = false;
    return false;
  }
  
  private delBlockedNumberValidatorLength(facilities: DataPackService){
    this.addFlagBlockedNumberLength = false;
    if(Math.abs(facilities.blockedNumber.length - this.oldBlockedNumberLength) >= 2 ){
      this.delFlagBlockedNumberLength = true;
      return true;
    }
    this.delFlagBlockedNumberLength = false;
    return false;
  }
  
  public existsMsisdn(opcao: DataPackService){  
    var exists = false;
    opcao.carriersList.forEach(option => {
      if (option.id === this.numeroAutorizado) {             
        exists = true;
      }
    });
    return exists;
  }

  public existsNumber(list: any[], choice: any){  
    var exists = false;
    list.forEach(option => {
      if (option.id === choice) {             
        exists = true;
      }
    });
    return exists;
  }

  public removeItemFromList(list: any[], choice: any){
    let index:number;
    var removed = false;
    list.forEach(option => {
      if (option.id === choice) {
        index = list.indexOf(option);
        removed = true
      }
    });
    list.splice(index, 1);
    return removed;
  }
  
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/voice/config/content.component.ts